export const campaignIntegrationsRoutes = {
  app: {
    getCampaignIntegrations: `/app/campaign-integrations`,
  },
  internal: {
    setUpIntegration: `/internal/campaign-integrations`,
    sendTestLead: `/internal/campaign-integrations/:campaignIntegrationsId/test`,
    deleteIntegration: `/internal/campaign-integrations/:id`,
    getIntegration: `/internal/campaign-integrations/:id`,
    updateIntegration: `/internal/campaign-integrations/:id`,
    sendTestEmailLead: `/internal/campaigns/:campaignId/email-integrations/test`,
  },
};
